<template>
  <div class="vm-contact">
    <div class="vm-avatar">
      <template v-if="contact.avatar">
          <img :src="contact.avatar" style="width:100%; height:100%; border-radius:50%; object-fit: scale-down;"/>
        </template>
        <template v-else>
      <div class="initials">
        {{ contact.name.first.charAt(0) + contact.name.last.charAt(0) }}
      </div>
      </template>
      <div v-if="contact.isOnline" class="vm-online-wrap" :style="{width: contact.isStream ? '20px': '14px', height: contact.isStream ? '20px': '14px', bottom: contact.isStream ? '-3px': '2px', right: contact.isStream ? '-3px': '2px'}" :title="contact.isStream ? 'на видеосвязи' : 'онлайн'">
        <div v-if="!contact.isStream" class="vm-online"></div>
        <webcam v-else />
      </div>
    </div>
    <div class="vm-info">
      <div class="vm-name">
        {{ contact.name.first }} {{ contact.name.last }}
      </div>
      <div class="drop-user">
      <span v-if="available() && $store.state.auth.user.id !== contact.id" @click="$emit('drop-user', contact)" title="исключить из комнаты" class="material-icons delete-user">person_remove</span>
      <span v-if="$store.state.auth.user.id === contact.id" @click="$emit('drop-user', contact)" title="выйти из комнаты" class="material-icons exit-room">login</span>
      <span v-if="$store.state.auth.user.id !== contact.id" @click="inviteToVideo(contact)" title="пригласить" class="material-icons alertUser">add_alert</span>
      </div>
    </div>
  </div>
</template>

<script>
import { chatApi } from '@app/services';
import webcam from '@app/assets/icons/webcam.svg?inline';
import toastr from 'toastr';

export default {
  components: {
    webcam
  },
  props: {
    contact: {
      time: Number,
      isOnline: Boolean,
      isStream: Boolean,
      name: {
        first: String,
        last: String
      }
    }
  },
  methods: {
    available() {
      let isAvail = false;
      if (this.$store.state.permission.resources.organization) {
        Object.keys(this.$store.state.permission.resources.organization).forEach(obj => {
          isAvail = isAvail ? isAvail : this.$store.state.permission.resources.organization[obj].roles.includes('doctor');
          isAvail = isAvail ? isAvail : this.$store.state.permission.resources.organization[obj].roles.includes('employee');
          isAvail = isAvail ? isAvail : this.$store.state.permission.resources.organization[obj].roles.includes('orgadmin');
        });
      }
      return isAvail;
    },
    async inviteToVideo(contact) {
      console.log(contact);
      const conversation_uuid = this.$route.params.uuid ? this.$route.params.uuid : this.$route.params.id;
      const { success_uuids, error_uuids } = await chatApi.sendInvitePush({ user_uuids: [contact.id], conversation_uuid });
      const status = success_uuids.indexOf(contact.id) > -1 ? 'send' :
          error_uuids.indexOf(contact.id) > -1 ? 'not_send' :
            'not_subscribe';
      if (status !== 'not_subscribe') {
        toastr.info('Приглашение отправлено');
      } else {
        toastr.error('Приглашение не отправлено');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.vm-contact {
  padding-left: 12px;
  display: flex;
  align-items: center;
}
.exit-room {
  transform: rotate(180deg);
}
.drop-user {
  display: none;
  align-self: center;
  justify-content: center;
}
.vm-contact:hover {
  .drop-user {
    display: flex;
    cursor: pointer;
    width: 50px;
    opacity: 0.6;
  }
}

.delete-user:hover {
  color: red;
}
.alertUser:hover {
  color: yellowgreen;
}
.vm-avatar {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 46px;
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.4);
  font-weight: 500;
  font-size: 14px;
  color: #fff;
}
.vm-online-wrap {
  position: absolute;
  display: flex;
  bottom: 2px;
  right: 2px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: RGB(87, 77, 128);
}
.vm-online {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: RGBA(126, 198, 98, 1);
  background-clip: padding-box;
  border: 1px solid transparent;
}
.vm-info {
  flex: auto;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  padding: 12px;
  height: 48px;
  box-sizing: content-box;
  display: flex;
  flex-direction: row;
}
.vm-name {
  font-weight: 500;
  color: #fff;
  width:70%;
}
@media (max-width: 1280px) {
  .vm-contact {
    font-size: 12px;
  }
  .vm-avatar {
    flex: 0 0 40px;
    width: 40px;
    height: 40px;
    font-size: 14px;
  }
  .vm-online-wrap {
    width: 12px;
    height: 12px;
  }
  .vm-online {
    width: 12px;
    height: 12px;
  }
  .vm-info {
    padding: 6px;
    height: 48px;
  }
}
</style>